import type { ConfirmationBlockDef, SectionDef } from '../forms/types.js';

export const C01_TEXT_VERSION = 'C01-v1';

/** Exact source wording — do not edit. A wording change requires a new text version. */
export const C01_TEXT =
  'I confirm that the information and assets provided are accurate and approved for the agreed work. I authorize the relevant team to use the approved information and assets for implementation, management, content, optimization and reporting. I understand that platform access should be granted through appropriate roles/permissions rather than password sharing.';

export const C01_CONFIRMATION: ConfirmationBlockDef = {
  code: 'C01',
  textVersion: C01_TEXT_VERSION,
  text: C01_TEXT,
};

/**
 * Builds the C01 confirmation section for a template. The `prefix` keeps field ids
 * unique per template (e.g. `f01_c01`), so each of the four templates owns its own block.
 */
export function buildC01Section(prefix: string): SectionDef {
  return {
    id: `${prefix}_c01`,
    key: 'confirmation',
    number: 'C01',
    title: 'Confirmation & Authorization',
    description: 'Signature here is an acknowledgement of accuracy and authorization; it is not a contractual e-signature.',
    fields: [
      { id: `${prefix}_c01_text`, key: 'c01_text', type: 'info', label: 'Confirmation', text: C01_TEXT, sourceRef: 'C01' },
      {
        id: `${prefix}_c01_ack`,
        key: 'c01_acknowledgement',
        type: 'acknowledgement',
        label: 'I confirm and authorize as stated above',
        text: C01_TEXT,
        required: true,
        editableBy: ['client'],
        sourceRef: 'C01',
      },
      { id: `${prefix}_c01_client_name`, key: 'c01_client_name', type: 'short_text', label: 'Client Name', required: true, sourceRef: 'C01' },
      { id: `${prefix}_c01_designation`, key: 'c01_designation', type: 'short_text', label: 'Designation', required: true, sourceRef: 'C01' },
      { id: `${prefix}_c01_signature`, key: 'c01_signature', type: 'signature', label: 'Signature', required: true, editableBy: ['client'], sourceRef: 'C01' },
      { id: `${prefix}_c01_date`, key: 'c01_date', type: 'date', label: 'Date', required: true, sourceRef: 'C01' },
      { id: `${prefix}_c01_authorized_by`, key: 'c01_authorized_by', type: 'short_text', label: 'Authorized By', required: true, sourceRef: 'C01' },
      { id: `${prefix}_c01_notes`, key: 'c01_approval_notes', type: 'long_text', label: 'Approval Notes', sourceRef: 'C01' },
    ],
  };
}
